import { useLocation, Navigate, Outlet } from 'react-router-dom'
import { useUser } from 'api/hooks/use-user'

export const PrivateRoutes = () => {
  const location = useLocation()
  const { user } = useUser()

  return user ? (
    <Outlet />
  ) : (
    <Navigate to="/auth" replace state={{ from: location }} />
  )
}
